module.exports = __webpack_public_path__ + "fonts/DM_Sans-800-latin-ext16.49935c4.woff2";